import { api } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const day = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
const STORE = { chilled: "Keep refrigerated 0–5°C", frozen: "Keep frozen -18°C or below", ambient: "Store cool and dry", hot: "Hot hold 63°C or above" };

export const LABEL_SIZES = [
  { id: "small", label: "Small 50 × 25mm", w: 50, h: 25, k: 0.75 },
  { id: "standard", label: "Standard 62 × 40mm", w: 62, h: 40, k: 1 },
  { id: "large", label: "Large 100 × 50mm", w: 100, h: 50, k: 1.35 },
];
const SIZE_KEY = "ka_label_size";
export const getLabelSize = () => (LABEL_SIZES.some((s) => s.id === localStorage.getItem(SIZE_KEY)) ? localStorage.getItem(SIZE_KEY) : "standard");
export const setLabelSize = (id) => localStorage.setItem(SIZE_KEY, id);

export async function labelBrand(business) {
  const line = business?.label_line || "";
  if (!business?.label_logo_id) return { line, logo: "" };
  try {
    const { data } = await api.get(`/photos/${business.label_logo_id}`, { responseType: "blob" });
    const logo = await new Promise((res) => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.onerror = () => res(""); fr.readAsDataURL(data); });
    return { line, logo };
  } catch {
    return { line, logo: "" };
  }
}

export function printLabels(batch, copies, venueName, target, sizeId = getLabelSize(), brand = {}) {
  const { w, h, k, id } = LABEL_SIZES.find((s) => s.id === sizeId) || LABEL_SIZES[1];
  const pt = (n) => `${(n * k).toFixed(1)}pt`;
  const small = id === "small";
  const made = new Date(batch.made_at).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  const allergens = batch.allergens.length ? batch.allergens.join(", ").toUpperCase() : "None of the 14";
  const safeLogo = /^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/.test(brand.logo || "") ? brand.logo : "";
  const one = `<div class="l"><div class="t">${safeLogo ? `<img class="g" src="${safeLogo}" alt="">` : ""}<div class="p">${esc(batch.product)}</div></div>
    <div class="u">USE BY <b>${esc(day(batch.use_by))}</b></div>
    <div class="r">Made ${esc(made)}${small ? "" : ` · ${esc(batch.made_by)}`}</div>
    ${small ? "" : `<div class="r">${esc(STORE[batch.storage])}${batch.quantity ? ` · ${esc(batch.quantity)}` : ""}</div>`}
    <div class="a">Allergens: ${esc(allergens)}</div>
    ${brand.line && !small ? `<div class="c">${esc(brand.line)}</div>` : ""}
    <div class="f"><span>${esc(batch.code)}</span>${small ? "" : `<span>${esc(venueName || "")}</span>`}</div></div>`;
  const win = target || window.open("", "_blank", "width=480,height=640");
  if (!win) return false;
  win.document.write(`<!doctype html><html><head><title>Labels ${esc(batch.code)}</title><style>
    @page { size: ${w}mm ${h}mm; margin: 0; }
    * { box-sizing: border-box; } body { margin: 0; font-family: Arial, Helvetica, sans-serif; color: #000; }
    .l { width: ${w}mm; height: ${h}mm; padding: ${small ? "1.2mm 1.8mm" : "2mm 2.5mm"}; display: flex; flex-direction: column; gap: .6mm; overflow: hidden; page-break-after: always; border: 1px dashed #bbb; }
    @media print { .l { border: 0; } }
    .t { display: flex; align-items: center; gap: 1.5mm; } .g { height: ${small ? "4mm" : `${(7 * k).toFixed(1)}mm`}; max-width: 35%; object-fit: contain; flex-shrink: 0; }
    .c { font-size: ${pt(6.5)}; font-style: italic; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .p { font-size: ${pt(11)}; font-weight: 800; line-height: 1.1; max-height: ${small ? "1.15em" : "2.3em"}; overflow: hidden; }
    .u { font-size: ${pt(10)}; background: #000; color: #fff; padding: .6mm 1.5mm; border-radius: 1mm; }
    .r { font-size: ${pt(6.5)}; } .a { font-size: ${pt(7)}; font-weight: 700; line-height: 1.15; overflow: hidden; }
    .f { margin-top: auto; display: flex; justify-content: space-between; gap: 2mm; font-size: ${pt(6.5)}; font-family: monospace; white-space: nowrap; overflow: hidden; }
  </style></head><body>${Array(Math.max(1, Math.min(50, copies))).fill(one).join("")}
  <script>window.onload = () => { window.print(); };</script></body></html>`);
  win.document.close();
  return true;
}
